import React, { useEffect, useState } from 'react';
import { Header } from './Header';
import { Autocomplete } from '@material-ui/lab';
import { Button, TextField } from '@material-ui/core';
import ApiCall from '../utils/ApiCall';
import { showErrorToast, showSuccessToast } from '../utils/toastMessage';

const PhoneList = () => {
    const [list, setList] = useState([]);
    const [selectedPhone, setSelectedPhone] = useState();

    useEffect(() => {
        async function data() {
            const response = await ApiCall('agency/GetPhoneNumbers', 'GET', null, true);
            console.log(response.data);
            setList(response.data);
        }
        data();
    }, []);

    const handleData = (e) => {
        const { name, value } = e.target;
        setSelectedPhone(prevState => ({ ...prevState, [name]: value }));
    }

    const savePhone = async () => {
        var params =
        {
            VehicleId: selectedPhone.VehicleId,
            Phone1: selectedPhone.Phone1,
            Phone2: selectedPhone.Phone2,
            Phone3: selectedPhone.Phone3
        };
        let response = ApiCall('agency/UpdatePhoneNumbers', 'POST', params, true);
        response.then(async (res) => {
            if (res.success) {
                showSuccessToast(res.message);
                const response = await ApiCall('agency/GetPhoneNumbers', 'GET', null, true);
                setList(response.data);
            }
            else
                showErrorToast(res.message);
        });
    }

    return (
        <div className="container">
            <Header />
            <>
                <div className="row">
                    <div className="col-md-12 textCenter">
                        <h3>
                            Telefon Düzenleme
                        </h3>
                    </div>
                </div>
                <div>
                    <div className="row">
                        <div className="col-md-4">
                            <Autocomplete
                                id="searchbox"
                                clearText="Temizle"
                                onChange={(event, value) => setSelectedPhone(value)}
                                options={list.data}
                                getOptionLabel={(option) => option['Plaka']}
                                noOptionsText='Plaka Bulunamadı'
                                // className="mb10 mt10"
                                style={{ width: '100%', fontSize: 14 }}
                                renderInput={(params) => <TextField {...params} label={"Plaka - Acenta"} variant="outlined" />}
                            />
                        </div>
                        {
                            selectedPhone &&
                            <>
                                <div className="col-md-4">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <TextField
                                                label={'Plaka - Acenta Adı'}
                                                variant={"outlined"}
                                                type={"text"}
                                                size={"medium"}
                                                disabled={true}
                                                inputProps={{
                                                    style: { fontWeight: 1200 }
                                                }}
                                                value={selectedPhone.Plaka}
                                            />
                                        </div>
                                    </div>
                                    <div className="row mt10">
                                        <div className="col-md-12">
                                            <TextField
                                                label={'GSM No'}
                                                variant={"outlined"}
                                                type={"text"}
                                                size={"medium"}
                                                disabled={true}
                                                value={selectedPhone.GsmNo}
                                            />
                                        </div>
                                    </div>
                                    <div className="row mt10">
                                        <div className="col-md-12">
                                            <TextField
                                                label={'Kısa Kod'}
                                                variant={"outlined"}
                                                type={"text"}
                                                size={"medium"}
                                                disabled={true}
                                                value={selectedPhone.ShortCode}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <TextField
                                                label={'Telefon 1'}
                                                variant={"outlined"}
                                                type={"text"}
                                                size={"medium"}
                                                name="Phone1"
                                                onChange={(e) => handleData(e)}
                                                value={selectedPhone.Phone1}
                                            />
                                        </div>
                                    </div>
                                    <div className="row mt10">
                                        <div className="col-md-12">
                                            <TextField
                                                label={'Telefon 2'}
                                                variant={"outlined"}
                                                type={"text"}
                                                size={"medium"}
                                                name="Phone2"
                                                onChange={(e) => handleData(e)}
                                                value={selectedPhone.Phone2}
                                            />
                                        </div>
                                    </div>
                                    <div className="row mt10">
                                        <div className="col-md-12">
                                            <TextField
                                                label={'Telefon 3'}
                                                variant={"outlined"}
                                                type={"text"}
                                                size={"medium"}
                                                name="Phone3"
                                                onChange={(e) => handleData(e)}
                                                value={selectedPhone.Phone3}
                                            />
                                        </div>
                                    </div>
                                </div>

                            </>
                        }
                    </div>
                    {
                        selectedPhone &&
                        <div className="row">
                            <div className="col-md-4"></div>
                            <div className="col-md-8 mt10">
                                <Button variant="contained" onClick={savePhone} className="w100" style={{ 'textTransform': 'none' }} color="primary">KAYDET</Button>
                            </div>
                        </div>
                    }
                </div>
            </>
            <hr />
            {
                list && list.data &&
                <>
                    <div className="row">
                        <div className="col-md-12 textCenter">
                            <h3>
                                Telefon Listesi Dökümü
                            </h3>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-3">
                            <b>
                                Plaka - Acenta
                            </b>
                        </div>
                        <div className="col-md-2">
                            <b>
                                Gsm No
                            </b>
                        </div>
                        <div className="col-md-1">
                            <b>
                                KısaKod
                            </b>
                        </div>
                        <div className="col-md-2">
                            <b>
                                Telefon 1
                            </b>
                        </div>
                        <div className="col-md-2">
                            <b>
                                Telefon 2
                            </b>
                        </div>
                        <div className="col-md-2">
                            <b>
                                Telefon 3
                            </b>
                        </div>
                    </div>
                </>
            }

            {
                list && list.data && list.data.map((info, index) =>
                    <div className={`row ${index % 2 === 0 ? 'evenRow' : 'oddRow'}`} key={index}>
                        <div className="col-md-3">
                            {info.Plaka}
                        </div>
                        <div className="col-md-2">
                            {info.GsmNo}
                        </div>
                        <div className="col-md-1">
                            {info.ShortCode}
                        </div>
                        <div className="col-md-2">
                            {info.Phone1}
                        </div>
                        <div className="col-md-2">
                            {info.Phone2}
                        </div>
                        <div className="col-md-2">
                            {info.Phone3}
                        </div>
                    </div>
                )
            }
        </div>
    );

}

export default PhoneList;